import React, { useEffect } from "react";

export default function Games() {
  
  return (
    <div className="container-fluid" style={{ padding: "20px 10px" }}>
    <div className="row">
      <div
        className="col-md-12 col-xs-12 center"
        style={{
          padding: 4,
          background: "rgb(227, 9, 9)",
          textAlign: "center",
          marginBottom: 10,
          color: "rgb(255, 255, 255)",
          fontSize: 16
        }}
      >
        <span>Virtual Casino</span>
      </div>
    </div>
    <div className="row">
      <div className="col-xs-6 col-md-2 center">
        <a href="javascript:void(0)">
          <img
            src="https://hrx99.com/images/default/vandbahar.jpeg"
            className="game-img"
            style={{ height: 140 }}
          />
        </a>
      </div>
      <div className="col-xs-6 col-md-2 center">
        <a href="javascript:void(0)">
          <img
            src="https://hrx99.com/images/default/vroulette.jpeg"
            className="game-img"
            style={{ height: 140 }}
          />
        </a>
      </div>
      <div className="col-xs-6 col-md-2 center">
        <a href="javascript:void(0)">
          <img
            src="https://hrx99.com/images/default/vduskadum.jpeg"
            className="game-img"
            style={{ height: 140 }}
          />
        </a>
      </div>
      <div className="col-xs-6 col-md-2 center">
        <a href="javascript:void(0)">
          <img
            src="https://hrx99.com/images/default/matka_1.png"
            className="game-img"
            style={{ height: 140 }}
          />
        </a>
      </div>
      <div className="col-xs-6 col-md-2 center">
        <a href="javascript:void(0)">
          <img
            src="https://hrx99.com/images/default/7ud_1.png"
            className="game-img"
            style={{ height: 140 }}
          />
        </a>
      </div>
      <div className="col-xs-6 col-md-2 center">
        <a href="javascript:void(0)">
          <div className="blink">
            <span className="blink-txt">New</span>
          </div>
          <img
            src="https://hrx99.com/images/default/av.png"
            className="game-img"
            style={{ height: 140 }}
          />
        </a>
      </div>
    </div>
    <div className="row">
      <div
        className="col-md-12 col-xs-12 center"
        style={{
          padding: 4,
          background: "rgb(227, 9, 9)",
          textAlign: "center",
          marginBottom: 10,
          color: "rgb(255, 255, 255)",
          fontSize: 16
        }}
      >
        <span>Live Casino</span>
      </div>
    </div>
    <div className="row">
      <div className="col-xs-6 col-md-2 center">
        <a href="/user/games/liveandarbahar/">
          <img src="https://hrx99.com/images/default/cano/ab2.jpg" className="game-img" />
        </a>
      </div>
      <div className="col-xs-6 col-md-2 center">
        <a href="/user/games/aaa/">
          <img src="https://hrx99.com/images/default/cano/aaa.jpg" className="game-img" />
        </a>
      </div>
      <div className="col-xs-6 col-md-2 center">
        <a href="/user/games/lucky7b/">
          <img src="https://hrx99.com/images/default/cano/lucky7b.jpg" className="game-img" />
        </a>
      </div>
      <div className="col-xs-6 col-md-2 center">
        <a href="/user/games/">
          <img src="https://hrx99.com/images/default/cano/tp20.jpg" className="game-img" />
        </a>
      </div>
      <div className="col-xs-6 col-md-2 center">
        <a href="/user/games/dt20/">
          <img src="https://hrx99.com/images/default/cano/dt20.jpg" className="game-img" />
        </a>
      </div>
      <div className="col-xs-6 col-md-2 center">
        <a href="/user/games/dt202/">
          <img src="https://hrx99.com/images/default/cano/dt202.jpg" className="game-img" />
        </a>
      </div>
    </div>
    <div className="row">
      <div className="col-xs-6 col-md-2 center">
        <a href="/user/games/">
          <div className="blink">
            <span className="blink-txt">New</span>
          </div>
          <img src="https://hrx99.com/images/default/cano/teen.jpg" className="game-img" />
        </a>
      </div>
      <div className="col-xs-6 col-md-2 center">
        <a href="javascript:void(0)">
          <div className="blink">
            <span className="blink-txt">Coming Soon</span>
          </div>
          <img src="https://hrx99.com/images/default/cano/lucky7.jpg" className="game-img" />
        </a>
      </div>
      <div className="col-xs-6 col-md-2 center">
        <a href="javascript:void(0)">
          <div className="blink">
            <span className="blink-txt">Coming Soon</span>
          </div>
          <img src="https://hrx99.com/images/default/cano/cmeter.jpg" className="game-img" />
        </a>
      </div>
      <div className="col-xs-6 col-md-2 center">
        <a href="javascript:void(0)">
          <div className="blink">
            <span className="blink-txt">Coming Soon</span>
          </div>
          <img src="https://hrx99.com/images/default/cano/cmeter1.jpg" className="game-img" />
        </a>
      </div>
    </div>
  </div>
  
  );
}
